import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "social mt-3",
  "aria-label": "breadcrumb",
  style: {"--bs-breadcrumb-divider":"''"}
}
const _hoisted_2 = { class: "breadcrumb breadcrumb-social d-flex justify-content-center" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "visually-hidden" }
const _hoisted_5 = {
  key: 1,
  class: "social mt-3 mb-4",
  "aria-label": "breadcrumb",
  style: {"--bs-breadcrumb-divider":"''"}
}
const _hoisted_6 = { class: "text-center black-50 my-2 fs-6 disclaimer px-3" }
const _hoisted_7 = {
  "aria-label": "breadcrumb",
  style: {"--bs-breadcrumb-divider":"'|'"}
}
const _hoisted_8 = { class: "breadcrumb py-3" }
const _hoisted_9 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  class: "breadcrumb-item"
}
const _hoisted_12 = {
  key: 2,
  class: "breadcrumb-item"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 3,
  class: "breadcrumb-item"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 4,
  class: "breadcrumb-item"
}
const _hoisted_17 = {
  key: 5,
  class: "breadcrumb-item"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 6,
  class: "breadcrumb-item"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 2,
  class: "text-center mt-2"
}
const _hoisted_22 = {
  key: 3,
  class: "text-center black-50 copyright mb-4"
}

import { onMounted, watch, ref, computed } from "vue";
    import LinkedTitleItem from '@/guiide/ts/linkedTitleItem';
    import { useStore } from "vuex";
    import { disabledConfig, FooterConfiguration } from "@/guiide/ts/configuration/footerConfiguration";
    import { Configuration } from "@/guiide/ts/configuration/configuration";
    import View from "@/guiide/ts/view";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
        paddingTop: { type: Number, default: 5 },
        marginTop: { type: Number, default: 5 }
    },
  setup(__props) {

    const props = __props;

    const store = useStore();
    const config = ref<FooterConfiguration>(disabledConfig);
    const additionalFooterClasses = ref<string>(`pt-${props.paddingTop} mt-${props.marginTop}`);

    const currentYear = new Date().getFullYear();

    const pageSpecificText = computed(() => {
        const view = store.state.configuration.activeView as View;
        const key = View[view].toLowerCase();
        return config.value.pageSpecificText?.[key] ?? undefined;
    });

    onMounted(() => {
        if (store?.state?.configuration?.footer) {
            config.value = store.state.configuration.footer;
        }
    })

    watch(
        () => store.state.configuration,
        (newConfig: Configuration) => {
            if (newConfig) {
                config.value = newConfig.footer;
            }
        }
    )

    function onCookieSettingsClick() {
        const handler = resolvePath(window, config.value.cookieSettings.href);
    
        if (handler && typeof handler === 'function') {
            handler();
        }
    }

    function resolvePath(root: any, path: string): unknown {
      return path.split('.').reduce((obj, key) => obj?.[key], root);
    }

    const socialMediaEntities: Array<LinkedTitleItem> = [
        new LinkedTitleItem('X', '', 'bi-twitter-x', 'https://twitter.com/guiidepensions?ref_src=twsrc%5Etfw'),
        new LinkedTitleItem('Facebook', '', 'bi-facebook', 'https://www.facebook.com/guiide.co.uk'),
        new LinkedTitleItem('Linkedin', '', 'bi-linkedin', 'https://www.linkedin.com/company/guiide')
    ];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass(["col-lg-9 mx-auto pt-2 m-5 d-flex flex-column align-items-center justify-content-center", additionalFooterClasses.value])
  }, [
    (config.value.socialMediaVisible)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createElementVNode("ol", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socialMediaEntities, (socialMediaEntity, i) => {
              return _createElementVNode("li", {
                key: i,
                class: "breadcrumb-item fs-3 px-3"
              }, [
                _createElementVNode("a", {
                  href: socialMediaEntity.src,
                  target: "_blank",
                  "data-show-count": "false",
                  "aria-label": "{{ socialMediaEntity.title }}"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["bi text-secondary", socialMediaEntity.icon])
                  }, null, 2),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(socialMediaEntity.title), 1)
                ], 8, _hoisted_3)
              ])
            }), 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock("nav", _hoisted_5)),
    _createElementVNode("div", _hoisted_6, [
      (pageSpecificText.value)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(pageSpecificText.value, (textItem, i) => {
            return (_openBlock(), _createElementBlock("p", {
              key: i,
              class: "fw-bold"
            }, _toDisplayString(textItem), 1))
          }), 128))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.text, (textItem, i) => {
        return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(textItem), 1))
      }), 128))
    ]),
    _createElementVNode("nav", _hoisted_7, [
      _createElementVNode("ol", _hoisted_8, [
        (config.value.aboutUs.visible)
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              _createElementVNode("a", {
                href: config.value.aboutUs.href,
                target: "_blank"
              }, "About Us", 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true),
        (config.value.drawdownCostComparerVisible)
          ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/drawdowncostcomparer",
                class: "breadcrumb-item"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Drawdown Charges Comparison")
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (config.value.privacyPolicy.visible)
          ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
              _createElementVNode("a", {
                href: config.value.privacyPolicy.href,
                target: "_blank"
              }, "Privacy Policy", 8, _hoisted_13)
            ]))
          : _createCommentVNode("", true),
        (config.value.cookiePolicy.visible)
          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
              _createElementVNode("a", {
                href: config.value.cookiePolicy.href,
                target: "_blank"
              }, "Cookie Policy", 8, _hoisted_15)
            ]))
          : _createCommentVNode("", true),
        (config.value.cookieSettings.visible)
          ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
              _createElementVNode("a", {
                onClick: _withModifiers(onCookieSettingsClick, ["prevent"]),
                target: "_self",
                class: "link-button",
                role: "button"
              }, "Cookie Settings")
            ]))
          : _createCommentVNode("", true),
        (config.value.termsAndConditions.visible)
          ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
              _createElementVNode("a", {
                href: config.value.termsAndConditions.href,
                target: "_blank"
              }, "Terms and Conditions", 8, _hoisted_18)
            ]))
          : _createCommentVNode("", true),
        (config.value.contactUs.visible)
          ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
              _createElementVNode("a", {
                href: config.value.contactUs.href
              }, "Contact Us", 8, _hoisted_20)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (config.value.logoVisible)
      ? (_openBlock(), _createElementBlock("p", _hoisted_21, _cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: "/content/images/guiide-logo.svg",
            alt: "Guiide logo",
            width: "80"
          }, null, -1)
        ])))
      : _createCommentVNode("", true),
    (config.value.copyrightVisible)
      ? (_openBlock(), _createElementBlock("p", _hoisted_22, "© 2013-" + _toDisplayString(_unref(currentYear)) + " Bespoke Retirements Limited", 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})